export const initialState = {
  actionProcessing: false,
  history: [],
  pages: 1,
};